import React from 'react';
import { useNavigate } from "react-router-dom"
import { useAuthWrapper } from './AuthWrapper';
import Header from './Header';
import Footer from './Footer';

const CustomerSupport = () => {

    const navigate = useNavigate();
    useAuthWrapper();

    return (
        <div>
            <div className="container">
                <Header showLogin={false} />
                <div style={{ marginTop: "2%" }}>
                    <div className="">
                        <div className="privacy-policy" style={{ marginTop: "7%" }}>
                          
                            
                           
                            {/* Add more sections here... */}

                            <br />
                            <h2>Contact Us</h2>
                            <br />
                            <p>If you have any inquiries regarding this Policy or any other query, kindly reach out to us at <a href="mailto:support@chatdragon.ai">support@chatdragon.ai</a>.</p>
                            <br />
                      
                           
                        </div>
                        <br />

                    </div>
                    <br />

                </div>

            </div>
            <Footer/>
        </div>


    );
};

export default CustomerSupport;
